/** PURE_IMPORTS_START ._WebSocketSubject PURE_IMPORTS_END */
import { WebSocketSubject } from './WebSocketSubject';
export var webSocket = WebSocketSubject.create;
//# sourceMappingURL=webSocket.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/observable/dom/webSocket.js
// module id = 767
// module chunks = 0